import client from "../api/client";

export const getList = () => {
  return client('/api/attachment-categories').then(({ data }) => data.data);
};

export const getTypeList = (type) => {
  return client('/api/attachment-categories/type/'+type).then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/attachment-categories/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/attachment-categories/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/attachment-categories', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/building-stat-types/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useAttachmentCategoryService () {
  return {
    getList,
    getTypeList,
    addEditModel,
    getDetail,
    delModel,
  };
}
